export const defaultStyle = {
    header: "text-center text-white text-3xl font-Light bg-[#00358e] leading-[34.5px] py-50 tracking-[1px]",
    linksWrpr:"lg:w-[1170px] py-90 mx-auto",
    listWrpr:"block w-[744px] max-w-full mx-auto my-0 p-0",
    list:"md:inline-block min-w-[170px] align-top ml-[34px] mb-30 pb-30 ",
    link:"font-Bold text-[25px] leading-[28.75px] hover:text-[#e30613] transition delay-150 duration-500 ease-in",
    innerlistWrpr:"border-l-2 mt-15 ml-15 pt-15 pl-15",
    innerlist:"pb-30 leading-[15px] last:pb-15",
    innerlink:"font-Bold text-[15px] leading-[15px] hover:text-[#e30613] transition delay-150 duration-500 ease-in"
}